import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate, useParams } from 'react-router-dom';
import classes from './styles.module.scss';
import { getInfrastructureProjects } from '../../../requests/public-infrastructure';
import { InfrastructureProjectType } from '../../../types/project.types';
import { ChevronRightIcon, PlusIcon } from '../../../assets/icons';
import { createInfrastructureProject } from '../../../requests/supervisor.request';
import { getLang } from '../../../helpers/utils';

const baseClass = 'infrastructure-projects-tab';
const translationKey = 'projects.improvement-projects';

const ImprovementProjectsList = () => {
    const { t } = useTranslation();
    const { kato } = useParams<{ tab: string; kato: string }>();
    const navigate = useNavigate();
    const [loading, setLoading] = useState(false);
    const [list, setList] = useState<any[]>([]);
    const key = InfrastructureProjectType.SNP_IMPROVEMENT;

    const handleAddObject = () => {
        if (!kato) return;
        createInfrastructureProject(Number(kato), key).then((res) => {
            const id = res.id
            navigate(`/admin/${kato}/SNP_IMPROVEMENT/${id}`);
        });
    };

    const editObject = (id: number) => {
        if (!kato) return;
        navigate(`/admin/${kato}/SNP_IMPROVEMENT/${id}`);
    };

    useEffect(() => {
        if (!kato) return;
        setLoading(true);

        getInfrastructureProjects(kato, key).then((data) => {
            setList(data);
        })
            .finally(() => setLoading(false));
    }, [kato]);

    if (!kato) return null;

    return (
        <div className={classes[baseClass]}>
            <div className={classes[`${baseClass}__list`]}>
                {!loading && list.map((item, index) => (
                    <div key={index} className={classes[`${baseClass}__item`]} onClick={() => editObject(item.id)}>
                        <span>{item[`name${getLang()}`] || t(`${translationKey}.name`)}</span>
                        <ChevronRightIcon />
                    </div>
                ))}
            </div>

            <button className={classes[`${baseClass}__btn`]} onClick={handleAddObject}>
                <PlusIcon /> {t('actions.add')}
            </button>
        </div>
    );
};

export default ImprovementProjectsList;
